module.exports = __webpack_public_path__ + "合作3.png?8f815e661e4542280a7e34bcc33d88d9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作3.png
// module id = 645
// module chunks = 0